import { useState, useEffect } from "react";
import male1 from "../../../assets/male_user.jpg";
import female1 from "../../../assets/user.jpg";
import CookiesServices from "../../../services/CookiesService";

const useTop10Item = (agentCode, agentGender) => {
  const defaultAvatar = agentGender === "F" ? female1 : male1;
  const [imgSrc, setImgSrc] = useState(defaultAvatar);
  const cookiesServices = new CookiesServices();

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const url = cookiesServices.toUrl('v1', `/agentprofile/profile-photo/${agentCode}`);
        const res = await fetch(
          url,
        );
        if (!res.ok) throw new Error("Failed to load");
        const blob = await res.blob();
        setImgSrc(URL.createObjectURL(blob));
      } catch (err) {
        setImgSrc(defaultAvatar);
      }
    };

    fetchImage(); 
  }, [agentCode, defaultAvatar]);

  return imgSrc;
};

export default useTop10Item;
